import React from 'react';
import { Box } from '@mui/material';

import PinguAnswerFeedback from './PinguAnswerFeedback';
import {
  AnswerFeedback,
  AnswerFeedbackReason,
  ChatMessage,
  ChatMessageFeedbackInput,
} from './types';
import TypedMarkdownMessage from './TypedMarkdownMessage';

const toAnswerFeedback = (
  feedback: ChatMessage['feedback'],
): AnswerFeedback | undefined => feedback && {
  rating: feedback.rating === 'like' ? 'positive' : 'negative',
  reason: feedback.reason,
  comment: feedback.comment,
};

const PinguAssistantMessage = ({
  message,
  index,
  pinned,
  onTyped,
  onMessageFeedback,
  onWithdrawFeedback,
}: {
  message: ChatMessage;
  index: number;
  pinned: boolean;
  onTyped: (messageIndex: number) => void;
  onMessageFeedback: (messageIndex: number, feedback: ChatMessageFeedbackInput) => Promise<boolean>;
  onWithdrawFeedback: (messageIndex: number) => Promise<boolean>;
}) => {
  const answerRef = React.useRef<HTMLDivElement>(null);

  return (
    <>
      <Box ref={answerRef}>
        <TypedMarkdownMessage
          content={message.content}
          animate={Boolean(message.justReceived)}
          messageIndex={index}
          onTyped={onTyped}
        />
      </Box>
      <PinguAnswerFeedback
        feedback={toAnswerFeedback(message.feedback)}
        pinned={pinned}
        canRate={message.messageIndex >= 0}
        getAnswerElement={() => answerRef.current}
        copyDisabled={Boolean(message.justReceived)}
        onRate={() => onMessageFeedback(message.messageIndex, { rating: 'like' })}
        onReport={(reason: AnswerFeedbackReason, comment: string) => onMessageFeedback(
          message.messageIndex,
          { rating: 'dislike', reason, comment: comment || undefined },
        )}
        onWithdraw={() => onWithdrawFeedback(message.messageIndex)}
      />
    </>
  );
};

export default PinguAssistantMessage;
